<div class="row mb-3">
	<div class="col-md-8">
		<div class="input-group">
			<input type="text"
				   class="form-control"
				   [placeholder]="'ontology-manager.variable.formula.select.input.variable.placeholder' | translate"
				   [(ngModel)]="searchText"
				   (ngModelChange)="filterVariables()">
			<button class="btn btn-outline-secondary" type="button"
					(click)="searchText=''; filterVariables()">
				<i class="fa fa-times"></i>
			</button>
		</div>
	</div>
</div>
<div *ngIf="isLoading" class="row">
	<div class="col-12 d-flex justify-content-center">
		<span *ngIf="isLoading" class="throbber throbber-2x"></span>
	</div>
</div>
<div class="row">
	<div class="col-md-12">
		<div class="scrollable-content">
			<div class="mb-3">
				<!-- Group by property.id -->
				<div *ngFor="let propertyGroup of filteredGroupedVariables | keyvalue; trackBy: trackByProperty">
					<h5 class="property-header mb-3">
						<img class="property-icon-lg me-1" alt="{{ 'study-editor.variable-select.property-alt' | translate }}"
							 src="content/images/property.svg">
						<span [innerHTML]="highlightText((propertyGroup.value[0]?.property?.name | uppercase) || ('study-editor.variable-select.other' | translate)) "></span>
						(<span
						[innerHTML]="highlightText(propertyGroup.value[0]?.property?.classes.toString())"></span>)
					</h5>

					<ul class="list-unstyled pe-3">
						@for (variable of propertyGroup.value; track variable) {
							<li class="pb-3 mb-3 border-bottom" [class.text-muted]="disableVariablesFromSelector.includes(Number(variable.id))">
								<div class="row">
									<div class="col-md-9">
										<span *ngIf="variable.alias" class="fw-bold"
											  [innerHTML]="highlightText(variable.alias + ' (' + variable.name + ')')"></span>
										<span *ngIf="!variable.alias" class="fw-bold"
											  [innerHTML]="highlightText(variable.name)"></span>
									</div>
									<div class="col-md-3 d-flex justify-content-end">
										@if (disableVariablesFromSelector.includes(Number(variable.id))) {
											<button class="btn btn-outline-success" disabled>
												<i class="fa fa-check fw-bold"></i>
												<span class="ps-1">Selected</span>
											</button>
										} @else {
											@if (selectionType === 'single') {
												<button type="button" class="btn btn-outline-info" (click)="onAddVariable(variable)">
													<span class="pe-1" jhiTranslate="select">Select</span>
													<i class="fa fa-chevron-right"></i>
												</button>
											} @else {
												<button type="button" class="btn btn-outline-info" (click)="onAddVariable(variable)">
													<i class="fa fa-plus"></i>
													<span class="ps-1" jhiTranslate="add">Add</span>
												</button>
											}
										}

									</div>
								</div>
								<div class="row mt-1 ms-2">
									<div class="col-md-6">
										<span class="fw-bold" jhiTranslate="ontology-manager.input-variable.method">Method:</span>
										{{ variable.method?.name }}
									</div>
									<div class="col-md-6">
										<span class="fw-bold" jhiTranslate="ontology-manager.input-variable.scale">Scale:</span>
										{{ variable.scale?.name }}
									</div>
								</div>
								@if (variable.formula?.definition) {
									<div class="row mt-1 ms-2">
										<div class="col-md-6">
											<span class="fw-bold" jhiTranslate="ontology-manager.input-variable.calculation">Calculation:</span>
											<div [innerHTML]="getFormula(variable)"></div>
										</div>
										<div class="col-md-6">
											<span class="fw-bold" jhiTranslate="ontology-manager.input-variable.input-variable">Input Variables:</span>
											<div>
												<ng-container *ngFor="let input of variable.formula.inputs; trackBy: trackByFormula">
													{{ input.name }}<br>
												</ng-container>
											</div>
										</div>
									</div>
								}
							</li>
						}
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>
